<header class="config-header">
  <h2>{{ "settings.sources" | transloco }}</h2>

  <div class="config-header-buttons">
    <div>
      <div
        class="ui toggle checkbox config-toggle"
        (click)="toggleConfigOperationMode(configOperations.export)"
      >
        <input type="checkbox" [ngModel]="configExportMode" />
        <label>{{ "settings.export-config-mode" | transloco }}</label>
      </div>
      @if (!isProductionMode) {
      <div
        class="ui toggle checkbox config-toggle"
        (click)="toggleConfigOperationMode(configOperations.delete)"
      >
        <input type="checkbox" [ngModel]="configDeleteMode" />
        <label>{{ "settings.delete-config-mode" | transloco }}</label>
      </div>
      }
    </div>
    <div>
      @if (!isProductionMode && !configExportMode && !configDeleteMode) {
      <div
        id="create-backup"
        class="ui primary background button"
        (click)="createBackup()"
        [ngClass]="{ loading: creatingBackup }"
      >
        {{ "settings.Create-Backup" | transloco }}
      </div>
      } @if (!isProductionMode && !configExportMode && !configDeleteMode) {
      <div
        id="create-new"
        class="ui primary background button"
        (click)="openSourceModal()"
      >
        {{ "settings.add-new-source" | transloco }}
      </div>
      }
    </div>
  </div>
</header>

<div class="config-export">
  @if (configExportMode || configDeleteMode) {
  <div class="config">
    @if (configExportMode || configDeleteMode) {
    <div class="config-date">
      <input
        type="date"
        placeholder="From date"
        [(ngModel)]="configOperationDate"
        (change)="filterSourcesOnDateChange()"
      />
    </div>
    } @if (configExportMode || configDeleteMode) {
    <button
      class="ui primary button background tiny config-button"
      (click)="openConfigOperationConfimationModal(configOperation)"
    >
      {{
        configExportMode
          ? ("settings.download-config" | transloco)
          : ("settings.delete-config" | transloco)
      }}
    </button>
    }
  </div>
  }
</div>

@if ( (!configExportMode && !configDeleteMode && sources?.length == 0) ||
((configExportMode || configDeleteMode) && sourcesForConfigExport?.length == 0)
) {
<div id="no-results">
  {{ "settings.no-sources-found" | transloco }}
</div>
} @if (sources?.length > 0 && !configExportMode && !configDeleteMode) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td width="300px">{{ "settings.name" | transloco }}</td>
      <td width="200px">{{ "settings.type" | transloco }}</td>
      <td>
        {{ uiConfig?.config?.atlasId }}
        {{ "settings.required-text" | transloco }}
      </td>
      <td>{{ "settings.config" | transloco }}</td>
      <td>{{ "settings.hidden" | transloco }}</td>
      @if (!isProductionMode) {
      <td></td>
      }
      <td></td>
    </tr>
  </thead>
  <tbody>
    @for (source of sources; track source) {
    <tr>
      <td>{{ source.name }}</td>
      <td class="type">
        {{ source.type === "csv" ? "CSV / XLSX" : source.type }}
      </td>
      <td>{{ source.requireAtlasId ? "Yes" : "No" }}</td>
      <td>{{ source.config }}</td>
      <td class="td-chkbox">
        <div class="ui checkbox" [title]="getHiddenTooltip()">
          <input
            type="checkbox"
            [checked]="source.hidden"
            [disabled]="!isSuperAdmin"
            (click)="saveSourceHidden(source, $event)"
          />
          <label></label>
        </div>
      </td>
      @if (!isProductionMode) {
      <td
        class="edit"
        align="right"
        (click)="openSourceModal(source)"
        [hidden]="
          source.type === 'prefill' ||
          source.type === 'questionnaire' ||
          source.type === 'travelDiary'
        "
      >
        {{ "settings.edit" | transloco }}
      </td>
      } @if ( source.type === 'prefill' || source.type === 'questionnaire' ||
      source.type === 'travelDiary' ) {
      <td></td>
      }
      <td
        class="questions"
        align="right"
        width="1px"
        [routerLink]="[source?.id]"
      >
        {{ "settings.questions" | transloco }}
      </td>
    </tr>
    }
  </tbody>
</table>
} @if ( (configExportMode || configDeleteMode) && sourcesForConfigExport?.length
> 0 ) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td>
        @if (!configDeleteMode) {
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
        }
      </td>
      <td width="300px">{{ "settings.name" | transloco }}</td>
      <td width="200px">{{ "settings.type" | transloco }}</td>
      <td>
        {{ uiConfig?.config?.atlasId }}
        {{ "settings.required-text" | transloco }}
      </td>
      <td>{{ "settings.config" | transloco }}</td>
      <th>{{ "settings.created" | transloco }}</th>
      <th>{{ "settings.updated" | transloco }}</th>
    </tr>
  </thead>
  <tbody>
    @for (configSource of sourcesForConfigExport; track configSource) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="configSource.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td>{{ configSource.name }}</td>
      <td class="type">
        {{ configSource.type === "csv" ? "CSV / XLSX" : configSource.type }}
      </td>
      <td>{{ configSource.requireAtlasId ? "Yes" : "No" }}</td>
      <td>{{ configSource.config }}</td>
      <td>{{ configSource.displayCreatedAt }}</td>
      <td>{{ configSource.displayUpdatedAt }}</td>
    </tr>
    }
  </tbody>
</table>
}

<div #sourceModal id="source-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>

  <h1 *transloco="let t">
    {{ source?.id ? t("settings.edit") : t("settings.new") }}
    {{ "settings.source" | transloco }}
  </h1>

  <form [formGroup]="form" (ngSubmit)="saveSource()">
    <div class="content">
      <div>
        <label>{{ "settings.name" | transloco }}</label>
        @if (source) {
        <input formControlName="name" type="text" name="srcName" />
        }
      </div>

      <div class="field">
        <label class="label-heading">{{
          "settings.file-type" | transloco
        }}</label>
        <mat-select
          class="selection form-control small"
          formControlName="fileType"
          (selectionChange)="checkSourceType()"
          placeholder="Select File Type"
        >
          @for (options of fileTypeOptions; track options) {
          <mat-option [value]="options.value" [attr.data-testid]="'source-type-option-' + options.value">
            {{ options.label }}
          </mat-option>
          }
        </mat-select>
      </div>
      @if (isSmartFormsEnabled) {
      <div class="field">
        <label class="label-heading">{{
          "settings.template-type" | transloco
        }}</label>
        <mat-select
          *transloco="let t"
          class="selection form-control small"
          formControlName="templateType"
          placeholder="{{ 'settings.template-type' | transloco }}"
        >
          @for (options of templateTypeOptions; track options) {
          <mat-option [value]="options.id">
            {{ options.templateType }}
          </mat-option>
          }
        </mat-select>
      </div>
      } @if (source) {
      <div class="radios-container">
        <div [ngClass]="{ disabled: fileType.value === 'pdf' }">
          <label
            >{{ "settings.require" | transloco }}
            {{ uiConfig?.config?.atlasId }}</label
          >
          <div class="radio-container">
            <label>
              <input
                formControlName="requireAtlasId"
                type="radio"
                name="requireAtlasId"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="radio-container">
            <label>
              <input
                formControlName="requireAtlasId"
                type="radio"
                name="requireAtlasId"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        @if (isSmartFormsEnabled) {
        <div>
          <label>{{
            "settings.Enable-data-standardisation" | transloco
          }}</label>
          <div class="radio-container">
            <label>
              <input
                formControlName="enableDataStandardisation"
                type="radio"
                name="enableDataStandardisation"
                [value]="true"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
            </label>
          </div>
          <div class="radio-container">
            <label>
              <input
                formControlName="enableDataStandardisation"
                type="radio"
                name="enableDataStandardisation"
                [value]="false"
              />
              <span class="checkmark"></span>
              <span class="lbl-text">{{ "settings.no" | transloco }}</span>
            </label>
          </div>
        </div>
        }
      </div>
      }

      <!-- <div *ngIf="source" class="radios-container" [ngClass]="{disabled: source?.id || fileType.value === 'pdf'}">
            <div [ngClass]="{disabled: fileType.value === 'oneteam'}">
              <label>{{ 'settings.Smart-Source' | transloco }}</label>
              <div class="radio-container">
                <label>
                  <input
                    formControlName="setSmartSource"
                    type="radio"
                    name="setSmartSource"
                    [value]="true"
                    (change)="updateValidator(true)"
                    />
                  <span class="checkmark"></span>
                  <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
                </label>
              </div>
              <div class="radio-container">
                <label>
                  <input
                    formControlName="setSmartSource"
                    type="radio"
                    name="setSmartSource"
                    [value]="false"
                    (change)="updateValidator()"
                    />
                  <span class="checkmark"></span>
                  <span class="lbl-text">{{ "settings.no" | transloco }}</span>
                </label>
              </div>
            </div>

            <div *ngIf="setSmartSource.value" [ngClass]="{ disabled: source?.id }">
              <label>{{ "settings.Enable-auto-tagging" | transloco }}</label>
              <div class="radio-container">
                <label>
                  <input
                    formControlName="autoTagging"
                    type="radio"
                    name="autoTagging"
                    [value]="true"
                    />
                  <span class="checkmark"></span>
                  <span class="lbl-text">{{ "settings.yes" | transloco }}</span>
                </label>
              </div>
              <div class="radio-container">
                <label>
                  <input
                    formControlName="autoTagging"
                    type="radio"
                    name="autoTagging"
                    [value]="false"
                    />
                  <span class="checkmark"></span>
                  <span class="lbl-text">{{ "settings.no" | transloco }}</span>
                </label>
              </div>
            </div>
          </div>

          <div *ngIf='setSmartSource.value' class="field" [ngClass]="{disabled: source?.taxReturnTypeId}">
            <label class="label-heading">{{taxReturnAlias}} {{ 'settings.type' | transloco }}</label>
            <mat-select
              class="selection form-control small"
              formControlName="taxReturnType"
              (selectionChange)="getCategories()"
              placeholder="{{ 'settings.Select-{{taxReturnAlias}}-Type' | transloco: {taxReturnAlias} }}">
              <mat-option
                *ngFor="let options of taxReturnTypeOptions"
                [value]="options.id">
                {{ options.name }}
              </mat-option>
            </mat-select>
          </div>

          <div *ngIf='setSmartSource.value' class="field" [ngClass]="{disabled: source?.categoryId}">
            <label class="label-heading">{{ 'settings.category' | transloco }}</label>
            <mat-select
              *transloco="let t;"
              class="selection form-control small"
              formControlName="category"
              (selectionChange)="getSubcategories()"
              placeholder="{{categoryOptions && categoryOptions.length ? t('settings.Select-Category'): t('settings.No-Category')}}">
              <mat-option *ngFor="let options of categoryOptions" [value]="options.id">
                {{ options.name }}
              </mat-option>
            </mat-select>
          </div>

          <div *ngIf='setSmartSource.value' class="field" [ngClass]="{disabled: source?.subcategoryId}">
            <label class="label-heading">{{ 'settings.subcategory' | transloco }}</label>
            <mat-select
              *transloco="let t;"
              class="selection form-control small"
              formControlName="subcategory"
              (selectionChange)="getSubgroups()"
              placeholder="{{subcategoryOptions && subcategoryOptions.length ? t('settings.Select-Subcategory'): t('settings.No-Subcategory')}}">
              <mat-option *ngFor="let options of subcategoryOptions" [value]="options.id">
                {{ options.name }}
              </mat-option>
            </mat-select>
          </div>

          <div *ngIf='setSmartSource.value' class="field" [ngClass]="{disabled: source?.subgroupId}">
            <label class="label-heading">{{ 'settings.subgroup' | transloco }}</label>
            <mat-select
              *transloco="let t;"
              class="selection form-control small"
              formControlName="subgroup"
              placeholder="{{subgroupOptions && subgroupOptions.length ?  t('settings.Select-Subgroup'): t('settings.No-Subgroup')}}">
              <mat-option *ngFor="let options of subgroupOptions" [value]="options.id">
                {{ options.name }}
              </mat-option>
            </mat-select>
          </div> -->

      <div>
        <label>{{ "settings.config" | transloco }}</label>
        @if (source) {
        <div class="config" formGroupName="config">
          <div class="ui toggle checkbox">
            <input type="checkbox" formControlName="cache" />
            <label>cache</label>
          </div>
          <div class="ui toggle checkbox">
            <input type="checkbox" formControlName="adminOnly" />
            <label>adminOnly</label>
          </div>
          <div class="ui toggle checkbox">
            <input type="checkbox" formControlName="subTypeRequired" />
            <label class="conflabel">subTypeRequired</label>
          </div>
        </div>
        }
      </div>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
      @if (!isProductionMode) {
      <button
        class="ui primary background approve button"
        [disabled]="form.invalid"
      >
        {{ "save" | transloco }}
      </button>
      }
    </div>
  </form>
</div>

<div #configExportConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.name" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (source of selectedSources; track source) {
      <tr>
        <td>{{ source.name }}</td>
        <td>{{ source.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedSources.length) {
  <p>
    {{ "settings.nothing-selected" | transloco }}
  </p>
  }
  <button
    class="ui primary button background tiny config-button"
    [ngClass]="{ disabled: !selectedSources.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>

<div #configDeleteCheckModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-delete" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.id" | transloco }}</th>
        <th>{{ "settings.name" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (source of selectedSources; track source) {
      <tr>
        <td>{{ source.id }}</td>
        <td>{{ source.name }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedSources.length) {
  <p>
    {{ "settings.nothing-selected" | transloco }}
  </p>
  }
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedSources.length }"
    (click)="deleteConfig({ confirmed: false, event: $event })"
  >
    {{ "settings.delete" | transloco }}
  </button>
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedSources.length }"
    (click)="clearDeleteConfig()"
  >
    {{ "settings.cancel" | transloco }}
  </button>
</div>

<div #configDeleteConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  @if (configDeletePossible) {
  <h2>
    {{ "settings.confirm-deletion" | transloco }}
  </h2>
  }
  <p>
    {{
      configDeletePossible
        ? ("settings.Deletion-of-the-selected-config-is-possible-Following-items-will-be-deleted-would-you-like-to-continue"
          | transloco)
        : ("settings.Deletion-of-the-selected-config-is-not-possible-resolve-the-dependencies-and-try-again"
          | transloco)
    }}
  </p>
  <div class="config-delete-table">
    <h4 class="config-delete-subtitle">{{ "settings.Sources" | transloco }}</h4>
    <table class="ui striped table">
      <thead>
        <tr>
          <th>{{ "settings.id" | transloco }}</th>
          <th>{{ "settings.name" | transloco }}</th>
          <th>{{ "settings.Dependencies" | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (source of deleteSources; track source) {
        <tr>
          <td>{{ source.id }}</td>
          <td>{{ source.name }}</td>
          <td>
            @if (source.sourceQuestions.length) {
            <h4>{{ "settings.Source-Questions" | transloco }}:</h4>
            } @for (dependentQuestion of source.sourceQuestions; track
            dependentQuestion) {
            <div>
              <div class="config-delete-dep">
                <div class="config-delete-dep-id">
                  {{ dependentQuestion.id }}
                </div>
                <div class="config-delete-dep-question">
                  {{ dependentQuestion.question }}
                </div>
              </div>
              @if ( !configDeletePossible &&
              dependentQuestion.calcDependencies.length ) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Dependent-Calc-Plans" | transloco }}
                  </div>
                  <ul>
                    @for ( dependentCalcPlan of
                    dependentQuestion.calcDependencies ; track
                    dependentCalcPlan) {
                    <li class="config-delete-dep-row">
                      {{ dependentCalcPlan }}
                    </li>
                    }
                  </ul>
                </div>
              </div>
              } @if (configDeletePossible) {
              <div>
                <div>
                  <div class="config-delete-dep-row-title">
                    {{ "settings.Total-Source-Answers" | transloco }}
                  </div>
                  <ul>
                    <li class="config-delete-dep-row">
                      {{ dependentQuestion.totalSourceAnswers }}
                    </li>
                  </ul>
                </div>
              </div>
              }
            </div>
            } @if (source.questions.length) {
            <h4>{{ "settings.Dependent-Questions" | transloco }}:</h4>
            } @for (dependentQuestion of source.questions; track
            dependentQuestion) {
            <div>
              <div class="config-delete-dep">
                <div class="config-delete-dep-id">
                  {{ dependentQuestion.id }}
                </div>
                <div class="config-delete-dep-question">
                  {{ dependentQuestion.question }}
                </div>
              </div>
            </div>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  @if (configDeletePossible) {
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedSources.length }"
    (click)="deleteConfig({ confirmed: true, event: $event })"
  >
    {{ "settings.confirm" | transloco }}
  </button>
  }
  <button
    class="ui primary button background tiny config-button-final"
    [ngClass]="{ disabled: !selectedSources.length }"
    (click)="clearDeleteConfig()"
  >
    {{ "settings.cancel" | transloco }}
  </button>
</div>
